import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Template } from '@app/models/performance/template.model';
import { NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { Review } from '@models/performance/review.model';
import { PerformanceResources } from '../performance.resource';

interface Report {
    subjectId: number;
    participants: number[];
}

@Injectable()
export class ReviewService {
    constructor(
        private auth: AuthService,
        private router: Router,
        private http: HttpClient,
        private notify: NotifyService
    ) {}

    userCanEditReview(review: Review): boolean {
        // If the user has the edit permission, and supervises the reviews subject employee
        if (this.auth.can(Review.permission.edit) && this.auth.supervises(review.subject)) {
            return true;
        }

        const isOwner = this.auth.employee.id === review.createdBy;
        const canAdministrate = this.auth.isAdmin();

        // If the user is the owner or the user has administrate permissions
        if (isOwner || canAdministrate) {
            return true;
        }

        return false;
    }

    onSave(review: Review, participants: Report[]): Promise<Object> {
        const url = PerformanceResources.ReviewCreation;

        const payload = {
            data: {
                type: 'reviews',
                attributes: {
                    templateId: review.templateId,
                    title: review.title,
                    instruction: review.instruction,
                    dueAt: review.dueAt,
                    periodStart: review.periodStart,
                    periodEnd: review.periodEnd,
                    scheduleAt: review.scheduleAt,
                    reoccuring: review.reoccuring,
                    subjectCanViewResults: review.subjectCanViewResults,
                    participantsCanViewResults: review.participantsCanViewResults,
                    subjectCanViewNote: review.subjectCanViewNote,
                    particpantsCanViewNote: review.participantsCanViewNote,
                    viewResultsBeforeCompletion: review.viewResultsBeforeCompletion,
                    attach: participants,
                },
            },
        };

        return this.http.post(url, payload).toPromise();
    }

    cloneAndRedirectToTemplate(template: Template, finallyCallback: Function): void {
        this.http
            .post(PerformanceResources.Duplicate.replace(':template', template.id.toString()), {})
            .toPromise()
            .then((res: Response) => {
                const id = res['data'].id;
                this.router.navigate(['/', 'performance', 'templates', id]);
            })
            .catch((err) => {
                this.notify.error(err.message || 'performance.templateIndex.duplicateError');
            })
            .finally(() => {
                finallyCallback();
            });
    }
}
